import './_manage-classname';
import './_global-nav';
import './_lax';
import './_parallax';

// サイトロゴの色を変える
const $logo = document.querySelector('.header .c3-logo');
const $logoType = $logo.querySelector('.c3-logo-logotype');
const darkElements = document.querySelectorAll('.dark-element');

// スクロールイベントリスナーを追加
window.addEventListener('scroll', function () {
  const areaRect = $logo.getBoundingClientRect();
  let isCovered = false; // 被覆状態を追跡するフラグ

  // darkElementsの各要素に対して処理を行う
  darkElements.forEach((element) => {
    const elementRect = element.getBoundingClientRect();

    // いずれかの要素がエリア内に入るか判定
    if (
      elementRect.top <= areaRect.bottom &&
      elementRect.bottom >= areaRect.top &&
      elementRect.left <= areaRect.right &&
      elementRect.right >= areaRect.left
    ) {
      isCovered = true; // 少なくとも一つの要素が被っている
    }
  });

  // 被覆状態に基づいてロゴの色を変更
  if (isCovered) {
    // 少なくとも一つの要素がエリア内に入った場合の処理
    $logoType.setAttribute('fill', '#fff');
  } else {
    // すべての要素がエリア外に出た場合の処理
    $logoType.setAttribute('fill', '#2f2f2f');
  }
});

document.addEventListener('DOMContentLoaded', function () {
  // .wpcf7-form内のすべての*マークを探す
  const forms = document.querySelectorAll('.wpcf7-form');

  forms.forEach(function (form) {
    const labels = form.querySelectorAll('b');

    labels.forEach(function (label) {
      // テキストノードとしての * を探す
      const nodes = Array.from(label.childNodes);
      nodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE && node.nodeValue.includes('*')) {
          // 新しい要素に置き換える
          const span = document.createElement('span');
          span.className = 'required';
          span.textContent = '*';
          label.replaceChild(span, node);
        }
      });
    });
  });
});

// copyrightの年を変更する
document.getElementById('copyright-year').textContent = new Date().getFullYear();

// 公開前に消す！

// document.addEventListener('DOMContentLoaded', function () {
//   const productionUrl = 'https://www.ccube.co.jp';
//   const links = document.querySelectorAll('a');

//   links.forEach(function (link) {
//     if (link.href.startsWith(productionUrl)) {
//       // 本番URLを相対URLに変換
//       link.href = link.href.replace(productionUrl, '');
//     }
//   });
// });
